@import (reference) '../../../../../../../constants/spacing.module.less';

.product-info {
  align-items: center;
}

.product-image {
  margin-right: @space-12;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: var(--grey-400);
  border-radius: 4px;
  overflow: hidden;
}

.image-placeholder {
  width: 40px;
  height: 40px;
}

.no-image-placeholder {
  display: block;
  width: 40px;
  height: 40px;
  background-color: var(--grey-400);
  border-radius: 4px;
}

.product-name {
  font-weight: 500;
  margin-bottom: @space-4;
}

.received-column,
.unreceived-column {
  text-align: center;
}

.received-column {
  width: 100%;
}

.received-column-text {
  margin-left: auto;
  color: var(--gray-56595D);
}

.empty-cell {
  min-height: 40px;
}
